import { action, observable } from "mobx";

import apiCaller from "@client/utils/ApiCaller";
import { Tag } from "@typings/Tag";

class TagStore {
  @observable loading = false;
  @observable tags: Tag[] = [];

  @action async load(opts?: {
    forceShowLoading?: boolean;
    hideLoading?: boolean;
  }): Promise<void> {
    this.loading = this.tags.length === 0;
    if (opts) {
      if (opts.hideLoading) this.loading = false;
      if (opts.forceShowLoading) this.loading = true;
    }
    try {
      const tags: Tag[] = await apiCaller.send({ url: "/tags" });
      this.loadSuccess(tags);
    } catch (err) {
      this.loadFailed();
    }
  }

  @action loadSuccess(tags: Tag[]) {
    this.loading = false;
    this.tags = tags;
  }

  @action loadFailed() {
    this.loading = false;
  }
}

export default new TagStore();
